import { render, staticRenderFns } from "./PFFiscalReport.vue?vue&type=template&id=55c8e7a0"
import script from "./PFFiscalReport.vue?vue&type=script&lang=js"
export * from "./PFFiscalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports